import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { ModalHeader } from './ModalHeader';
import { ModalFooter } from './ModalFooter';

const ContentWrapper = styled.div`
  padding: 35px 40px 0;

  @media (max-width: 767px) {
    padding: 25px 20px 0;
  }
`;

const TextWrapper = styled.div`
  margin-bottom: 30px;
`;

const Text = styled.div`
  font-size: 16px;
  line-height: 30px;
  color: ${(props) => props.color};
  font-weight: ${(props) => props.fontWeight || 300};
`;

const Description = styled(Text)`
  font-size: 22px;
  margin-bottom: 30px;
`;

const contentConfig = [
  {
    questionKey: 'site.purchase.select-package.carbon.what-is-it',
    answerKey: 'site.purchase.select-package.carbon.what-is-it.text',
  },
  {
    questionKey: 'site.purchase.select-package.carbon.how-to-calculate',
    answerKey: 'site.purchase.select-package.carbon.how-to-calculate.text',
  },
  {
    questionKey: 'site.purchase.select-package.carbon.fee',
    answerKey: 'site.purchase.select-package.carbon.fee.text',
  },
];

export const ModalContent = (props) => {
  const { colorStyle, closeModal } = props;
  const { t } = useTranslation();

  return (
    <>
      <ModalHeader closeModal={closeModal} />

      <ContentWrapper>
        <Description fontWeight="500" color={colorStyle}>
          {t('site.purchase.select-package.carbon.modal-description')}
        </Description>
        {contentConfig.map(({ questionKey, answerKey }) => (
          <TextWrapper key={questionKey}>
            <Text fontWeight="500" color={colorStyle}>
              {t(questionKey)}
            </Text>
            <Text>{t(answerKey)}</Text>
          </TextWrapper>
        ))}
      </ContentWrapper>

      <ModalFooter />
    </>
  );
};

ModalContent.propTypes = {
  colorStyle: PropTypes.string,
  closeModal: PropTypes.func,
};
